import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_tr.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.tr.js'
import 'moment/locale/tr.js'
import './translations.tc.tr.js'

$.fn.datepicker.defaults.language = 'tr'

I18n.defaultLocale = 'tr'
I18n.locale = 'tr'

export default App
